function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '',
        active = swatches.querySelector('.product-card-swatch.active');

      swatch_list.forEach((swatch, index) => {

        swatch.addEventListener('mouseover', function () {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}
/**
 *  @class
 *  @function Header
 */
class Header {
  constructor() {
    const header = document.querySelector('.header-section'),
      header_main = document.getElementById('header'),
      menu = document.getElementById('mobile-menu'),
      toggle = document.querySelector('.mobile-toggle-wrapper'),
      close = document.querySelector('.moblie-close'),
      overlay = document.querySelector('.moblie-overlay'),
      setHeaderOffset = this.setHeaderOffset,
      setAnnouncementHeight = this.setAnnouncementHeight,
      setHeaderHeight = this.setHeaderHeight;
    if (!header_main) {
      return;
    }
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          toggle.removeAttribute('open');
          toggle.classList.remove('active');
        }
      }
    });
    toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
      setAnnouncementHeight(header);
      // if (toggle.classList.contains('active')) {
      //   e.preventDefault();
      //   document.body.classList.remove('overflow-hidden');
      //   toggle.classList.remove('active');
      //   this.closeAnimation(toggle);

      // } else {
      document.body.classList.add('overflow-hidden');
      setTimeout(() => {
        toggle.classList.add('active');
      });
      // }
      document.querySelector('#Avada-FAQ_Widget .Avada-Faqs_Button').style.zIndex = 0
      window.dispatchEvent(new Event('resize.resize-select'));
    });
    close.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.remove('overflow-hidden');
      toggle.classList.remove('active');
      this.closeAnimation(toggle);
      window.dispatchEvent(new Event('resize.resize-select'));
      document.querySelector('#Avada-FAQ_Widget .Avada-Faqs_Button').style.zIndex = 999999
    });
    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.remove('overflow-hidden');
      toggle.classList.remove('active');
      this.closeAnimation(toggle);
      window.dispatchEvent(new Event('resize.resize-select'));
      document.querySelector('#Avada-FAQ_Widget .Avada-Faqs_Button').style.zIndex = 999999
    });

    // Mobile Menu offset
    window.addEventListener('scroll', function () {
      setHeaderOffset(header);
      setHeaderHeight(header_main);
      // Sticky Header Class
      if (header_main.classList.contains('header-sticky--active')) {
        let offset = parseInt(header_main.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;

        header_main.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }

    }, {
      passive: true
    });
    window.dispatchEvent(new Event('scroll'));

    if (document.getElementById('shopify-section-announcement-bar')) {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      window.addEventListener('resize', function () {
        setAnnouncementHeight(a_bar);
      }, {
        passive: true
      });
      window.dispatchEvent(new Event('resize'));
    }
    // Buttons.
    menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    menu.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  setAnnouncementHeight(a_bar) {
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty('--announcement-height', h + 'px');
  }
  setHeaderOffset(header) {
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--header-offset', h + 'px');
  }
  setHeaderHeight(header) {
    let h = header.clientHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');
    const isOpen = detailsElement.hasAttribute('open');

    setTimeout(() => {
      if (isOpen) {
        detailsElement.classList.remove('menu-opening');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      }
      else {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }
    }, 100);
  }
  onCloseButtonClick(event) {
    if (event.target.classList[0] != "disclosure__button" && event.target.closest('button').classList[0] != "disclosure__button") {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  }
  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        detailsElement.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          details.classList.remove('submenu-open');
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll('.thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener('resize', debounce(function () {
        _this.resizeSubMenus();
      }, 100));

      window.dispatchEvent(new Event('resize'));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');
        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.parentElement.clientWidth + 10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}
/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    constructor() {
      super();
      let cc = document.querySelector('.click-capture');

      // Add functionality to buttons
      this.addEventListener('click', (e) => this.close_panel(e));
      document.addEventListener('panel:close', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
      cc.addEventListener('click', (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel) {
          this.close_panel(e, panel[0]);
        }
      });
    }

    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e.target.closest('.side-panel');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer')) {
        this.close_quick_view(panel);
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view(panel) {
      panel = panel ? panel : document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {
  constructor() {
    if (((this.container = document.getElementById('Cart-Drawer')), !this.container)) return;
    let e = document.getElementById('cart-drawer-toggle');

    // ▼ 追加: すでに初期化済みの場合は、内部のイベントだけ再バインドして処理を抜ける（重複登録の防止）2026-09-07
    if (this.container.dataset.initialized === 'true') {
      this.notesToggle();
      this.removeProductEvent();
      this.updateFreeShipping();
      this.termsCheckbox();
      return;
    }
    this.container.dataset.initialized = 'true';
    // ▲ 

    this.container.addEventListener('click', (event) => {
      // ① 既存: チェックボックスの処理
      if (event.target && event.target.id === 'JS_Gift_Add_Check') {
        this.ChangeStyle(event.target);

        if (event.target.checked == true) {
          this.ChangeGift(event.target.value);
        } else if (event.target.checked == false) {
          this.ChangeGift('0');
        }
      }

      // ② 追加: ギフトアイコン（gift_icn）がクリックされた時の処理
      if (event.target.closest('.gift_icn')) {
        // クリックのたびに最新の要素を取得する
        const desc = this.container.querySelector('.gift_desc');
        if (desc && !desc.classList.contains('active')) {
          desc.classList.add('active');
        }
      }

      // ③ 追加: 閉じるボタン（gift_close）がクリックされた時の処理
      if (event.target.closest('.gift_close')) {
        const desc = this.container.querySelector('.gift_desc');
        if (desc && desc.classList.contains('active')) {
          desc.classList.remove('active');
        }
      }
    });

    this.container.querySelectorAll('.quantity input');
    (e.addEventListener('click', (e) => {
      (e.preventDefault(),
        document.body.classList.add('open-cc'),
        document.body.classList.add('open-cart'),
        this.container.classList.add('active'),
        this.container.focus(),
        setTimeout(() => {
          this.container.querySelector('.product-recommendations--full') && this.container.querySelector('.product-recommendations--full').classList.add('active');
        }),
        dispatchCustomEvent('cart-drawer:open'));
    }),
      (this.debouncedOnChange = debounce((e) => {
        this.onChange(e);
      }, 300)),
      this.container.addEventListener('change', this.debouncedOnChange.bind(this)),
      this.notesToggle(),
      this.removeProductEvent(),
      this.updateFreeShipping(),
      this.termsCheckbox());

    // ▼ ここから追加: フラグとMutationObserverによるDOM監視
    this.isRemovingGift = false;
    const observer = new MutationObserver(() => {
      this.checkGiftConditions();
    });
    observer.observe(this.container, { childList: true, subtree: true });

    // インスタンス化された直後（ページ読み込み時）にも一度チェックを走らせる
    this.checkGiftConditions();
  }

  // ▼ 新規追加: 409エラー（カートの競合）発生時に自動でリトライする安全なFetch関数
  async fetchWithRetry(url, options, retries = 3) {
    for (let i = 0; i < retries; i++) {
      const response = await fetch(url, options);
      if (response.status === 409) {
        console.warn(`Shopify Cart API Locked (409). Retrying... (${i + 1}/${retries})`);
        // 409が出た場合は500ミリ秒待ってから再トライ
        await new Promise(resolve => setTimeout(resolve, 500));
        continue;
      }
      return response; // 成功、または409以外のエラーならそのまま返す
    }
    return fetch(url, options); // 最終トライ
  }

  onChange(e) {
    e.target.classList.contains('qty') && this.updateQuantity(e.target.dataset.index, e.target.value);
  }
  removeProductEvent() {
    try {
      let e = this.container.querySelectorAll('.remove');
      e.forEach((e) => {
        e.addEventListener('click', (e) => {
          (this.updateQuantity(e.target.dataset.index, '0'), e.preventDefault());
        });
      });
    } catch (error) {
      console.error('Remove::Error occurred while setting up remove product event:', error);
    }
  }
  getSectionsToRender() {
    return [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
    ];
  }
  getSectionInnerHTML(e, t) {
    return new DOMParser().parseFromString(e, 'text/html').querySelector(t).innerHTML;
  }
  termsCheckbox() {
    let e = this.container.querySelector('#CartDrawerTerms'),
      t = this.container.querySelector('.button.checkout');
    e &&
      t &&
      (e.setCustomValidity(theme.strings.requiresTerms),
        t.addEventListener('click', function (t) {
          e.checked || (e.reportValidity(), e.focus(), t.preventDefault());
        }));
  }
  notesToggle() {
    let e = document.getElementById('order-note-toggle');
    e &&
      (e.addEventListener('click', (t) => {
        e.nextElementSibling.classList.add('active');
      }),
        e.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((t) => {
          t.addEventListener('click', (t) => {
            (e.nextElementSibling.classList.remove('active'), this.saveNotes());
          });
        }));
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: document.getElementById('mini-cart__notes').value }),
    });
  }
  updateFreeShipping() {
    const e = this.container.querySelector('.free-shipping');
    if (e) {
      let t = e.querySelector('.free-shipping--text span'),
        s = parseInt(e.dataset.cartTotal, 10),
        n = Math.round(parseInt(e.dataset.minimum, 10) * (Shopify.currency.rate || 1)),
        i = 1;
      if (s < n && ((i = s / n), t)) {
        let e = n - s,
          i = window.theme.settings.money_with_currency_format || '${{amount}}';
        t.innerHTML = formatMoney(e, i);
      }
      e.style.setProperty('--percentage', i);
    }
  }// ▼ 差し替え: 順番(line)ではなく固有キー(id)をShopifyに送信する
  updateQuantity(e, t) {
    // 固有キーには「:」記号が含まれるため、CSSエラーにならないよう [id="..."] の属性セレクタを使用
    const itemNode = this.container.querySelector(`[id="CartDrawerItem-${e}"]`);
    if (itemNode) itemNode.classList.add('thb-loading');

    // line: e ではなく id: e に変更し、対象の商品を完全に狙い撃ちする
    const s = JSON.stringify({
      id: e,
      quantity: t,
      sections: this.getSectionsToRender().map((e) => e.section),
      sections_url: window.location.pathname
    });

    dispatchCustomEvent('line-item:change:start', { quantity: t });

    if (this.container.querySelector('.product-recommendations--full')) {
      this.container.querySelector('.product-recommendations--full').classList.remove('active');
    }

    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: s
    })
      .then((res) => res.text())
      .then((text) => {
        const n = JSON.parse(text);

        this.renderCartState(n);

        dispatchCustomEvent('line-item:change:end', { quantity: t, cart: n });

        const updatedItemNode = this.container.querySelector(`[id="CartDrawerItem-${e}"]`);
        if (updatedItemNode) updatedItemNode.classList.remove('thb-loading');

        // ▼ 追加: カート更新後にギフトラッピングの条件をチェックする2026-09-07
        this.checkGiftWrapping(n);

      });
  }

  // ▼ 追加: ギフトラッピングの個数超過・単独購入をチェックし削除するメソッド
  checkGiftWrapping(cartState) {
    if (!cartState || !cartState.items) return;

    const GIFT_PRODUCT_ID = 9439383290163; // ギフトラッピングの商品ID
    let targetKey = null;
    let isInvalidNumber = false;
    let isOnlyGift = false;

    // カート内をループしてギフトラッピングを探す
    for (let i = 0; i < cartState.items.length; i++) {
      const item = cartState.items[i];
      if (item.product_id === GIFT_PRODUCT_ID) {
        if (item.quantity >= 2) {
          targetKey = item.key; // Drawerはkeyを受け取る仕様なのでそのまま保持
          isInvalidNumber = true;
        } else if (cartState.items.length === 1) {
          targetKey = item.key;
          isOnlyGift = true;
        }
        break; // ギフト商品が見つかったらループ終了
      }
    }

    // 条件に合致した場合、アラートを出して自動削除
    if (targetKey && (isInvalidNumber || isOnlyGift)) {
      if (isInvalidNumber) {
        alert('Alert: The gift wrapping quantity is invalid. \nIt will be removed from your cart.');
      } else if (isOnlyGift) {
        alert('Alert: Gift wrapping is not available for purchase on its own. \nIt will be removed from your cart.');
      }

      // CartDrawerのupdateQuantityは id(key) を受け取る仕様なので、targetKeyをそのまま渡す
      this.updateQuantity(targetKey, 0);
    }
  }

  /* Gift */
  ChangeStyle(e) {
    e.disabled = true;
    e.setAttribute('style', 'opacity:0; visibility: hidden;');
    const giftArea = document.getElementById('Gift_Add_Check_Area');
    if (giftArea) giftArea.classList.add('loading');
  }

  /* Gift */
  async ChangeGift(addGift_V) {
    var deleteGiftV_array =
      typeof currentGiftV_array !== 'undefined'
        ? currentGiftV_array.filter(function (item) {
          return item && item !== '' && item != addGift_V;
        })
        : [];

    try {
      if (addGift_V != '0') {
        await this.AddGift(addGift_V);
        // ▼ 予防策: Add完了後、Shopifyサーバー側のロック解除が完全に終わるよう300msだけ待機する
        await new Promise(resolve => setTimeout(resolve, 300));
      }

      const newState = await this.DeleteGift(deleteGiftV_array);

      if (newState && newState.sections) {
        this.renderCartState(newState);

        const giftArea = document.getElementById('Gift_Add_Check_Area');
        if (giftArea) giftArea.classList.remove('loading');
      }
    } catch (error) {
      console.error('error:' + error);
      alert('エラー:' + error);
    }
  }

  async AddGift(addGift_V) {
    let formData = {
      updates: {
        [addGift_V]: 1
      }
    };

    try {
      // ▼ 修正2: '/cart/add.js' から '/cart/update.js' に変更
      const response = await this.fetchWithRetry(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`レスポンスステータス: ${response.status}`);
      }

      return await response.json();

    } catch (error) {
      console.error('Add:', error);
      return Promise.reject('Add:' + error);
    }

    // if (addGift_V == '0') {
    //   console.log('No Add Data');
    //   return Promise.resolve();
    // }
    // var formData = {
    //   items: [
    //     {
    //       id: addGift_V,
    //       quantity: 1,
    //     },
    //   ],
    // };

    // try {
    //   const response = await this.fetchWithRetry('/cart/add.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(formData),
    //   });

    //   if (!response.ok) {
    //     throw new Error(`レスポンスステータス: ${response.status}`);
    //   }

    //   return await response.json();
    // // ▼ 元のエラー出力処理を復元
    // } catch (error) {
    //   console.error('Add:', error);
    //   return Promise.reject('Add:' + error);
    // }
  }

  async DeleteGift(deleteGift_V) {
    const update_list = {};
    deleteGift_V.forEach((element) => {
      update_list[element] = 0;
    });

    const requestBody = {
      updates: update_list,
      sections: this.getSectionsToRender().map((e) => e.section),
      sections_url: window.location.pathname,
    };

    try {
      const response = await this.fetchWithRetry(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`レスポンスステータス: ${response.status}`);
      }

      return await response.json();

      // ▼ 元のエラー出力処理を復元
    } catch (error) {
      console.error('Delete:', error);
      return Promise.reject('Delete:' + error);
    }
  }

  // レンダー関数の共通化
  renderCartState(n) {
    this.getSectionsToRender().forEach((e) => {
      const t = document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id);
      if (t && n.sections) {
        t.innerHTML = this.getSectionInnerHTML(n.sections[e.section], e.selector);
      }
    });
    this.removeProductEvent();
    this.notesToggle();
    this.termsCheckbox();
    this.updateFreeShipping();
  }
  // ▼ ここから追加: ギフトとスーツの競合を判定・削除するメソッド
  checkGiftConditions() {
    const conflictFlag = document.getElementById('GiftSuitConflictFlag');

    if (conflictFlag && !window.isRemovingGift) {
      window.isRemovingGift = true;

      // 修正: 2回目以降のアラートを防ぐため、検知した瞬間にDOMから目印を即座に消去する
      conflictFlag.remove();

      alert('We are sorry. \nThe gift option cannot be selected because the product contains items that cannot be gift-packed.');

      // ギフトを削除し、通信が完全に終わってから余裕を持ってストッパーを解除する
      this.ChangeGift('0').finally(() => {
        setTimeout(() => {
          window.isRemovingGift = false;
        }, 500);
      });
    }
  }
  /* Gift */
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.hide();
      }
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-localization-forms').forEach((localization) => {
      localization.addEventListener('change', (e) => {
        localization.querySelector('form').submit();
      });
    });
  }
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      if (document.body.classList.contains('animations-true') && typeof gsap !== 'undefined') {
        setTimeout(() => {
          this.prepareAnimations();
          this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
        }, 400);
      }
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'sine.inOut',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.6,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      e.preventDefault();
      if (this.tl.reversed()) {
        this.tl.timeScale(1).play();
      } else {
        this.tl.timeScale(3).reverse();
      }
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}
/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;

      if (!handle) {
        return;
      }
    }
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && typeof (recentIds) !== undefined) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof Localization !== 'undefined') {
    new Localization();
  }
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }
  if (typeof Header !== 'undefined') {
    new Header();
  }
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});